(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/active-exclusions-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/active-exclusions-abtest.js');
'use strict';

const {
  Constants
} = svs.selfExclusion;
const {
  ExclusionViewAbTest,
  NanExcluded
} = svs.selfExclusion.components;
const ActiveExclusionsAbTest = _ref => {
  let {
    exclusions,
    naExcluded
  } = _ref;
  return React.createElement("section", {
    className: "exclusion-pause-wrapper exclusion-rounded-corners padding-xs-h-2"
  }, naExcluded && React.createElement("div", {
    className: "exclusion-pause-wrapper"
  }, React.createElement(NanExcluded, {
    exclusions: exclusions,
    url: Constants.URL.EXCLUSION
  })), !naExcluded && exclusions && React.createElement("div", {
    className: "exclusion-pause-wrapper padding-xs-h-1 padding-xs-bottom-2"
  }, React.createElement(ExclusionViewAbTest, {
    exclusions: exclusions
  })));
};
svs.selfExclusion.components.ActiveExclusionsAbTest = ActiveExclusionsAbTest;

 })(window);